// src/axiosConfig.js
import axios from 'axios';

const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');


const instance = axios.create({
baseURL: '/api',
//baseURL: 'http://192.168.100.6:8000/api',
 //baseURL: 'http://192.168.0.128:8000/api',
 //baseURL: 'http://192.168.100.179:8000/api',//casa e patti
 // baseURL: 'http://192.168.1.28:8000/api',

  headers: {
    'X-CSRF-TOKEN': token,
    'Content-Type': 'application/json',
  },
});

// Interceptor para manejar errores globales
instance.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export default instance;

